export function getHeadingSegments({
  includeSpouse,
  isModified,
  currentAge,
  planAge,
  spousePlanAge,
  spouseName,
}) {
  const isPushingOutRetirement = !isModified && planAge > currentAge

  if (isPushingOutRetirement) {
    return {
      showHelpIcon: true,
      segments: [
        { text: 'Consider retiring at ' },
        { text: `${planAge}`, bold: true },
        { text: ` instead of ${currentAge}.` },
      ],
    }
  }

  if (includeSpouse) {
    if (spousePlanAge === planAge) {
      return {
        showHelpIcon: false,
        segments: [
          { text: `You and ${spouseName} plan on retiring at ` },
          { text: `${planAge}`, bold: true },
          { text: '.' },
        ],
      }
    }

    return {
      showHelpIcon: false,
      segments: [
        { text: 'You plan on retiring at ' },
        { text: `${planAge}`, bold: true },
        { text: `, and ${spouseName} at ` },
        { text: `${spousePlanAge}`, bold: true },
        { text: '.' },
      ],
    }
  }

  if (planAge === currentAge) {
    return {
      showHelpIcon: false,
      segments: [
        { text: 'You plan on retiring at ' },
        { text: `${planAge}`, bold: true },
        { text: '.' },
      ],
    }
  }

  return {
    showHelpIcon: false,
    segments: [
      { text: 'You plan on retiring at ' },
      { text: `${planAge}`, bold: true },
      { text: ` instead of ${currentAge}.` },
    ],
  }
}
